<template><div><h1 id="sortimentsliste-export-fur-excel" tabindex="-1"><a class="header-anchor" href="#sortimentsliste-export-fur-excel"><span>Sortimentsliste, Export für Excel</span></a></h1>
<p>Sortimentsliste, Export für Excel — Detaillierte Informationen für den Einkauf</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste mit detaillierten Informationen, welche für den Einkauf relevant sind. Selektiert wird nach dem eingegebenen Mediumcode. Wenn das System so parametrisiert ist, dass ein beliebiger Mediumcode für alle Artikel erlaubt ist, werden nur diejenigen Artikeln gezeigt, für die zumindest 1 Auftrag existiert. Die Berücksichtigung zukünftiger neuer Verkaufspreise kann beeinflusst werden.</p>
<p>Pfad: <code v-pre>Logistik → Auswertungen → Sortimentsliste</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Mediumcode</dt>
<dd>Mediumcode</dd>
<dt>neue Preise bis</dt>
<dd>neue Preise nur bis zum eingegebenen Datum berücksichtigen, inklusive</dd>
<dt>Ausgabe</dt>
<dd>Standard (Textdatei)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Arb. Seite</td>
<td>Seitennummer des Katalogs</td>
</tr>
<tr>
<td>PM</td>
<td>Produkt Manager</td>
</tr>
<tr>
<td>Layout Seite</td>
<td>Abbildungscode z.B. Einzel-Doppelseite</td>
</tr>
<tr>
<td>Artikel-Nr.Fotolz</td>
<td>Artikelnummer</td>
</tr>
<tr>
<td>Artikel-Bezeichnung</td>
<td>Artikelbezeichnung</td>
</tr>
<tr>
<td>Typ</td>
<td>Artikeltyp</td>
</tr>
<tr>
<td>Lieferant Lief.Art.Nr</td>
<td>Lieferantennummer</td>
</tr>
<tr>
<td>EK</td>
<td>Einkaufspreis</td>
</tr>
<tr>
<td>Währ.</td>
<td>Währung für Einkauf</td>
</tr>
<tr>
<td>Kurs</td>
<td>Kurs für Umrechnung in Sfr.</td>
</tr>
<tr>
<td>Rabatt %</td>
<td>Rabatt zum Listenpreis aus [Lieferantenartikel]</td>
</tr>
<tr>
<td>Eink. Spesen %</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>Einst. Stück</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>VK Stück</td>
<td>Verkaufspreis</td>
</tr>
<tr>
<td>MWST-Code</td>
<td>Artikel MWST-Code</td>
</tr>
<tr>
<td>Satz %</td>
<td>Artikel MWST-Satz in %</td>
</tr>
<tr>
<td>Mar. %</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>Progn. Stück</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>Progn. E.Wert</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>Progn. V.Wert</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>Mar. %</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>Init Order Stück</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>Init Order E.Wert</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>Init Order V.Wert</td>
<td>wird nicht benutzt</td>
</tr>
<tr>
<td>mehrere EK</td>
<td>ja/nein, Existieren mehrere Einkaufspreise bei diesem Artikel?</td>
</tr>
<tr>
<td>mehrere Lieferanten</td>
<td>ja/nein, Existieren mehrere Lieferanten bei diesem Artikel?</td>
</tr>
</tbody>
</table>
<p>Sortimentsliste                         Werbentitel             Auswertung Medium 01
Arb.    PM      Layout  Artikel-        Artikel-        Typ     Lieferant       EK      Währ.   Kurs    Rabatt  Eink.   Einst.  VK      MWSt-Code       Satz    Mar.    Progn.  Progn.  Progn.  Mar.    Init.Order      Init.Order      Init.Order      mehrere mehrere
Seite           Seite   Nr.Fotolz       Bezeichnung             Lief.Art.Nr.                            %       Spesen %        Stück   Stück           %       %       Stück   E.Wert  V.Wert  %       Stück   E.Wert  V.Wert  EK      Lieferanten
0       MB1             019600  Briefumschläge A        N       366877  0       CHF     1       0                       0       i       7.5
0       MB1             029600  Briefumschläge BO       N       366877  0       CHF     1       0                       0       i       7.5
0       MB1             039600  Briefumschläge P        N       366877  0                       0                       0       i       7.5
0       MB1             059600  Briefumschläge Q        N       366877  0       CHF     1       0                       0       i       7.5
2       1LC     10      14342N  Leupin; Karte   N       366877  1.95    CHF     1       25                      2.6     i       7.5
2       1LC     10      14346N  Leupin; Karte   N       366877  0       CHF     1       0                       2.6     i       7.5
2       1LC     10      14355N  Huegin; Karte   N                                                               2.6     i       7.5</p>
<p>Lesebeispiel: Die Karte Leupin, im Katalog auf Seite 2 wird vom Lieferanten 366877 geliefert. Der Einkaufspreis beträgt SFr. 1.95, Umrechnungskurs 1:1. Wir erhalten 25 % Rabatt auf diesem Artikel. Der Verkaufspreis beträgt also Fr. 2.60, inkl. 7,5 % MWST.</p>
</div></template>


